// @ts-nocheck — 디자인 원본 스크립트 포팅 (product.js 의 드래그 워크플로우 빌더 데모)
import type { Scope } from './scope';

/** 기능소개 히어로: 팔레트에서 노드를 끌어다 놓고, 연결하고, 실행해 보는 체험용 빌더 */
export function initProductBuilder(root: ParentNode, s: Scope) {
  const { setTimeout, addEventListener } = s;
  const T = {
    sch: { n: '스케줄', c: '트리거', ic: 'clock', bg: 'var(--org)', f: [['실행 주기', '매일'], ['실행 시각', '09:00']] },
    chat: { n: '채팅 시작', c: '트리거', ic: 'msg', bg: 'var(--grn)', f: [['시작 조건', '사용자 메시지 수신'], ['시작 메시지', '무엇을 도와드릴까요?']] },
    doc: { n: '문서 검색', c: '액션', ic: 'doc', bg: 'var(--blu)', f: [['지식베이스', '사내 규정 KB'], ['Top K', '5'], ['유사도 임계값', '0.70']] },
    ai: { n: 'AI 응답 (LLM)', c: '모델 · 프롬프트 설정', ic: 'spark', bg: 'var(--pnk)', f: [['모델', 'Claude Sonnet 4'], ['답변 다양성 (Temperature)', '0.7'], ['AI 지침 (시스템 프롬프트)', '사내 규정을 근거로 답변'], ['최대 토큰 수', '1024']] },
    judge: { n: '판단', c: '액션', ic: 'branch', bg: '#F97316', f: [['조건', '답변 근거 문서 있음'], ['조건 불일치 시', '담당자 연결']] },
    mail: { n: '이메일 커넥터', c: '커넥터', ic: 'mail', bg: 'var(--ac)', f: [['연결 방식', 'SMTP / IMAP'], ['받는 사람', 'team@company.com']] },
    web: { n: '웹검색', c: '커넥터', ic: 'globe', bg: '#2563EB', f: [['검색 범위', '전체 웹'], ['결과 수', '5']] },
    gd: { n: 'Google Drive', c: '커넥터', img: '/site/logos/google-drive.svg', f: [['폴더', '사내 문서'], ['동작', '파일 읽기']] },
    slack: { n: 'Slack', c: '커넥터', img: '/site/logos/slack.svg', f: [['채널', '#general'], ['동작', '메시지 보내기']] },
    notion: { n: 'Notion', c: '커넥터', img: '/site/logos/notion.svg', f: [['페이지', '사내 위키'], ['동작', '페이지 읽기']] },
    mcp: { n: 'MCP 서버', c: '커넥터', ic: 'server', bg: '#191F28', f: [['서버', '사내 MCP'], ['동작', '도구 호출']] },
  };
  const W = 168,
    H = 56;
  const demo = root.querySelector('.pd-demo');
  if (!demo) return;
  const stg = demo.querySelector('.pd-stg'),
    svg = stg.querySelector('svg.wr'),
    set = demo.querySelector('.pd-set'),
    st = demo.querySelector('.pd-tb .st'),
    toast = demo.querySelector('.pd-toast'),
    hint = stg.querySelector('.hint'),
    cur = demo.querySelector('.pd-demo-cur');
  let nodes = [],
    edges = [],
    slot = null,
    sel = null,
    uid = 0,
    running = false,
    touched = false;
  demo.querySelectorAll('.pd-it').forEach((b) => {
    const im = b.querySelector('img'),
      t = T[b.dataset.k];
    if (im && t && t.img) t.img = im.src;
  });
  const icon = (t) =>
    t.img ? `<span class="ic w"><img src="${t.img}" alt=""></span>` : `<span class="ic" style="background:${t.bg}"><svg class="i"><use href="#${t.ic}"></use></svg></span>`;
  function mkNode(k, x, y, anim) {
    const t = T[k],
      el = document.createElement('div');
    el.className = 'pd-nd' + (anim ? ' new' : '');
    el.innerHTML = `${icon(t)}<span class="tx">${t.n}<small>${t.c}</small></span><span class="pi"></span><span class="po"></span><button class="x" title="삭제"><svg class="i"><use href="#x"></use></svg></button><span class="ok"><svg class="i"><use href="#check"></use></svg></span>`;
    const n = { id: ++uid, k, x, y, el, v: t.f.map((f) => f[1]) };
    place(n);
    stg.appendChild(el);
    nodes.push(n);
    bindNode(n);
    return n;
  }
  function place(n) {
    const mw = stg.clientWidth - W - 8,
      mh = stg.clientHeight - H - 8;
    n.x = Math.max(8, Math.min(mw, n.x));
    n.y = Math.max(36, Math.min(mh, n.y));
    n.el.style.left = n.x + 'px';
    n.el.style.top = n.y + 'px';
  }
  const pOut = (n) => [n.x + W + 1, n.y + H / 2],
    pIn = (n) => [n.x - 1, n.y + H / 2];
  const curve = (a, b) => {
    const dx = Math.max(40, Math.abs(b[0] - a[0]) / 2);
    return `M${a[0]} ${a[1]} C${a[0] + dx} ${a[1]} ${b[0] - dx} ${b[1]} ${b[0]} ${b[1]}`;
  };
  function draw() {
    let h = '';
    edges.forEach((e) => {
      const a = nodes.find((n) => n.id === e.a),
        b = nodes.find((n) => n.id === e.b);
      if (a && b) h += `<path class="w${e.hot ? ' hot' : ''}" data-e="${e.a}-${e.b}" d="${curve(pOut(a), pIn(b))}"></path>`;
    });
    if (slot && slot.from) {
      const a = nodes.find((n) => n.id === slot.from);
      if (a) h += `<path class="w ds" d="${curve(pOut(a), [slot.x, slot.y + H / 2])}"></path>`;
    }
    if (tmp) h += `<path class="w tmp" d="${curve(tmp.a, tmp.b)}"></path>`;
    svg.innerHTML = h;
  }
  svg.addEventListener('click', (e) => {
    const p = e.target.closest('path[data-e]');
    if (!p || running) return;
    const [a, b] = p.dataset.e.split('-').map(Number);
    edges = edges.filter((x) => !(x.a === a && x.b === b));
    draw();
  });
  let tmp = null;
  function local(e) {
    const r = stg.getBoundingClientRect();
    return [e.clientX - r.left, e.clientY - r.top];
  }
  function select(n) {
    sel = n;
    nodes.forEach((m) => m.el.classList.toggle('sel', m === n));
    renderSet();
  }
  function renderSet() {
    if (!sel) {
      set.innerHTML = '<h5>노드 설정</h5><div class="pd-sb">선택한 노드의 세부 설정</div><div class="em">캔버스의 노드를 선택하면<br>설정 항목이 표시됩니다.</div>';
      return;
    }
    const t = T[sel.k];
    set.innerHTML =
      `<span class="ty">${t.c === '모델 · 프롬프트 설정' ? '액션' : t.c}</span><h5>${t.n}</h5><div class="pd-sb">노드 설정</div>` +
      t.f.map((f, i) => `<label>${f[0]}</label><input data-i="${i}" value="${sel.v[i]}">`).join('');
    set.querySelectorAll('input').forEach((inp) =>
      inp.addEventListener('input', () => {
        sel.v[+inp.dataset.i] = inp.value;
      }),
    );
  }
  function touch() {
    if (touched) return;
    touched = true;
    cur.classList.remove('go');
    cur.style.opacity = 0;
    hint.classList.add('off');
  }
  function bindNode(n) {
    n.el.querySelector('.x').addEventListener('pointerdown', (e) => e.stopPropagation());
    n.el.querySelector('.x').addEventListener('click', (e) => {
      e.stopPropagation();
      if (running) return;
      remove(n);
    });
    n.el.querySelector('.po').addEventListener('pointerdown', (e) => {
      e.stopPropagation();
      e.preventDefault();
      if (running) return;
      touch();
      tmp = { a: pOut(n), b: local(e) };
      draw();
      const mv = (ev) => {
        tmp.b = local(ev);
        draw();
      };
      const up = (ev) => {
        removeEventListener('pointermove', mv);
        removeEventListener('pointerup', up);
        const t = document.elementFromPoint(ev.clientX, ev.clientY),
          te = t && t.closest('.pd-nd'),
          m = te && nodes.find((q) => q.el === te);
        if (m && m !== n && !edges.some((x) => x.a === n.id && x.b === m.id) && !edges.some((x) => x.a === m.id && x.b === n.id)) edges.push({ a: n.id, b: m.id });
        tmp = null;
        draw();
      };
      addEventListener('pointermove', mv);
      addEventListener('pointerup', up);
    });
    n.el.addEventListener('pointerdown', (e) => {
      if (e.button !== 0) return;
      e.preventDefault();
      touch();
      const s0 = local(e),
        ox = n.x,
        oy = n.y;
      let moved = false;
      const mv = (ev) => {
        const p = local(ev);
        if (!moved && Math.hypot(p[0] - s0[0], p[1] - s0[1]) < 4) return;
        moved = true;
        n.el.classList.add('dragging');
        n.x = ox + p[0] - s0[0];
        n.y = oy + p[1] - s0[1];
        place(n);
        draw();
      };
      const up = () => {
        removeEventListener('pointermove', mv);
        removeEventListener('pointerup', up);
        n.el.classList.remove('dragging');
        if (moved) trySlot(n);
        select(n);
      };
      addEventListener('pointermove', mv);
      addEventListener('pointerup', up);
    });
  }
  function remove(n) {
    n.el.remove();
    nodes = nodes.filter((m) => m !== n);
    edges = edges.filter((e) => e.a !== n.id && e.b !== n.id);
    if (sel === n) {
      sel = null;
      renderSet();
    }
    syncPal();
    draw();
  }
  function nearSlot(x, y) {
    return slot && Math.hypot(x - slot.x, y - slot.y) < 110;
  }
  function trySlot(n) {
    if (!nearSlot(n.x, n.y)) return false;
    n.x = slot.x;
    n.y = slot.y;
    place(n);
    if (slot.from && !edges.some((e) => e.b === n.id)) edges.push({ a: slot.from, b: n.id });
    const m = nodes.find((q) => q.id === slot.to);
    if (m && !edges.some((e) => e.a === n.id && e.b === m.id)) edges.push({ a: n.id, b: m.id });
    slot.el.remove();
    slot = null;
    draw();
    return true;
  }
  function syncPal() {
    demo.querySelectorAll('.pd-it').forEach((b) => {
      b.classList.toggle('pick', !!slot && b.dataset.k === 'ai' && !touched);
    });
  }
  // palette drag
  demo.querySelectorAll('.pd-it').forEach((b) =>
    b.addEventListener('pointerdown', (e) => {
      if (e.button !== 0 || running) return;
      e.preventDefault();
      touch();
      syncPal();
      const k = b.dataset.k,
        t = T[k];
      const g = document.createElement('div');
      g.className = 'pd-nd pd-ghost';
      g.innerHTML = `${icon(t)}<span class="tx">${t.n}<small>${t.c}</small></span>`;
      document.body.appendChild(g);
      const mv = (ev) => {
        g.style.left = ev.clientX - W / 2 + 'px';
        g.style.top = ev.clientY - H / 2 + 'px';
        const p = local(ev);
        if (slot) slot.el.classList.toggle('ov', nearSlot(p[0] - W / 2, p[1] - H / 2));
      };
      mv(e);
      const up = (ev) => {
        removeEventListener('pointermove', mv);
        removeEventListener('pointerup', up);
        g.remove();
        const r = stg.getBoundingClientRect();
        if (ev.clientX >= r.left && ev.clientX <= r.right && ev.clientY >= r.top && ev.clientY <= r.bottom) {
          const p = local(ev);
          const n = mkNode(k, p[0] - W / 2, p[1] - H / 2, true);
          trySlot(n);
          select(n);
          draw();
        } else if (slot) slot.el.classList.remove('ov');
      };
      addEventListener('pointermove', mv);
      addEventListener('pointerup', up);
    }),
  );
  // run
  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
  function pulse(e) {
    return new Promise((res) => {
      const p = svg.querySelector(`path[data-e="${e.a}-${e.b}"]`);
      if (!p) return res();
      e.hot = true;
      p.classList.add('hot');
      const L = p.getTotalLength(),
        c = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
      c.setAttribute('r', '6');
      c.setAttribute('class', 'pls');
      svg.appendChild(c);
      const t0 = performance.now(),
        D = 650;
      (function f(t) {
        const k = Math.min(1, (t - t0) / D),
          q = p.getPointAtLength(L * (k < 0.5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2));
        c.setAttribute('cx', q.x);
        c.setAttribute('cy', q.y);
        if (k < 1) requestAnimationFrame(f);
        else {
          c.remove();
          res();
        }
      })(t0);
    });
  }
  async function run() {
    if (running || !nodes.length) return;
    running = true;
    touch();
    nodes.forEach((n) => n.el.classList.remove('done', 'act'));
    edges.forEach((e) => (e.hot = false));
    draw();
    st.className = 'st run';
    st.querySelector('b').textContent = '실행 중';
    toast.classList.remove('on');
    const inc = new Set(edges.map((e) => e.b));
    let q = nodes.filter((n) => !inc.has(n.id)).sort((a, b) => (T[b.k].c === '트리거') - (T[a.k].c === '트리거'));
    const seen = new Set();
    while (q.length) {
      const nx = [];
      for (const n of q) {
        if (seen.has(n.id)) continue;
        seen.add(n.id);
        n.el.classList.add('act');
        await sleep(380);
        n.el.classList.remove('act');
        n.el.classList.add('done');
        const outs = edges.filter((e) => e.a === n.id);
        await Promise.all(outs.map(pulse));
        outs.forEach((e) => {
          const m = nodes.find((z) => z.id === e.b);
          if (m && !seen.has(m.id)) nx.push(m);
        });
      }
      q = nx;
    }
    st.className = 'st done';
    st.querySelector('b').textContent = '실행 완료';
    toast.querySelector('b').textContent = slot ? '빈 노드를 채우면 흐름이 완성됩니다' : '워크플로우 실행 완료';
    toast.classList.add('on');
    setTimeout(() => toast.classList.remove('on'), 2600);
    running = false;
  }
  function reset() {
    if (running) return;
    nodes.forEach((n) => n.el.remove());
    nodes = [];
    edges = [];
    if (slot) slot.el.remove();
    slot = null;
    sel = null;
    st.className = 'st';
    st.querySelector('b').textContent = '편집 중';
    toast.classList.remove('on');
    init();
  }
  demo.querySelector('[data-run]').addEventListener('click', run);
  demo.querySelector('[data-reset]').addEventListener('click', reset);
  demo.querySelector('[data-save]').addEventListener('click', () => {
    toast.querySelector('b').textContent = '워크플로우 저장 완료';
    toast.classList.add('on');
    setTimeout(() => toast.classList.remove('on'), 2000);
  });
  function init() {
    const w = stg.clientWidth,
      gap = Math.max(28, (w - 56 - W * 3) / 2),
      c0 = 28,
      c1 = c0 + W + gap,
      c2 = c1 + W + gap,
      y = Math.max(110, stg.clientHeight * 0.3);
    const a = mkNode('chat', c0, y),
      b = mkNode('doc', c1, y),
      m = mkNode('mail', c2, y + 130);
    edges.push({ a: a.id, b: b.id });
    const se = document.createElement('div');
    se.className = 'pd-slot';
    se.textContent = 'AI 응답 노드를 여기에 놓으세요';
    se.style.left = c2 + 'px';
    se.style.top = y + 'px';
    stg.appendChild(se);
    slot = { x: c2, y, el: se, from: b.id, to: m.id };
    select(b);
    syncPal();
    draw();
    if (!touched)
      requestAnimationFrame(() => {
        const dr = demo.getBoundingClientRect(),
          it = demo.querySelector('.pd-it[data-k="ai"]').getBoundingClientRect(),
          sr = se.getBoundingClientRect();
        cur.style.setProperty('--x0', it.left - dr.left + 'px');
        cur.style.setProperty('--y0', it.top - dr.top - 8 + 'px');
        cur.style.setProperty('--x1', sr.left - dr.left + 'px');
        cur.style.setProperty('--y1', sr.top - dr.top + 'px');
        cur.classList.add('go');
      });
  }
  init();
  let rt;
  addEventListener('resize', () => {
    clearTimeout(rt);
    rt = setTimeout(() => {
      nodes.forEach(place);
      draw();
    }, 150);
  });
  // 페이지를 벗어날 때 body 에 붙은 드래그 고스트 정리
  s.onDispose(() => document.querySelectorAll('.pd-ghost').forEach((g) => g.remove()));
}
